import React, { Component } from 'react';
import { Theme } from '@material-ui/core/styles';
import { withStyles, createStyles } from "@material-ui/core/styles";
import { Badge } from "@material-ui/core";
import './index.css';

import { Card } from './CampaignCards';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: "25px",
      boxShadow: "-1px 3px 6px 2px rgba(0,0,0,0.2);"

    },
    image: {
      width: 60,
      height: 60,
      // marginRight: "20px",
      borderRadius: "50px",
      backgroundColor: "#BFEAF1",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      margin: "auto"
    },
    img: {
      margin: 'auto',
      display: 'block',
      marginTop: "20px",
      fontSize: "30px"
    },
    numbervalue: {
      color: "#22494e",
      fontSize: "16px",
      textAlign: 'center' as 'center',
      margin: "8px 0px 0px 0px",
    },
    root: {
      flexGrow: 1,
    },
    cardtxt: {
      margin: "5px auto 0px"
    },
    itemname: {
      color: "#627995",
      fontSize: "18px"
    },
    cardicon: {
      border: "2px solid #00B878",
      borderRadius: "25px",
      padding: "5px 10px",
      fontWeight: 600,
      backgroundColor: "#00B878",
      color: "white",
      position: 'absolute' as 'absolute',
      right: 0,
      top: 0,
    },
    cardtxtdiv: {
      padding: "7px",
      marginLeft: "15px",
      [theme.breakpoints.between('sm', 'lg')]: {
        marginLeft: "30px",
      }
    },
    cardcontainer: {
      width: "100%",
      boxShadow: "0px 2px 4px 2px grey"
    },
  })
);

interface CardProps {
  cards: Card[];
  onClick(card: Card): void;
}


export const CampaignsCardMobile = (props: CardProps) => {
  const classes = useStyles();

  return (
    <div style={{ display: "flex" }}>
      {props.cards.map((card, index) => (
        <div
          key={`card-${index}`}
          onClick={() => props.onClick(card)} 
          style={{ width: "25%" }}
        >
          {card.cardicon ?
            (<Badge anchorOrigin={{ vertical: 'top', horizontal: 'right' }} className="badge" color="error" badgeContent={card.cardicon}>
              <div>
                <div className={classes.image}>
                  {<card.avatarIcon style={{ color: card.avatarIconColor }} />}
                </div>
                <p className={classes.numbervalue}>{card.value}</p>
              </div>
            </Badge>) : (
              <div>
                <div className={classes.image}>
                  {<card.avatarIcon style={{ color: card.avatarIconColor }} />}
                </div>
                <p className={classes.numbervalue}>{card.value}</p>
              </div>)}
        </div>
      ))}
    </div>
  );

}
export default CampaignsCardMobile;


// WEBPACK FOOTER //
// ./src/components/campaign/CampaignCardMobile.tsx